var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "filogix-details-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush bt-0" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grey-text text-darken-3 col text-left align-self-center",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("settings.accountTab.lenderSubmissionDetails")
                      ) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-auto text-right single-line-height vertical-center",
                },
                [
                  _c("synced-with-expert-status", { staticClass: "mr-2" }),
                  _vm._v(" "),
                  _c("simple-button", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: { title: _vm.syncFromExpertTooltipText },
                        expression: "{ title: syncFromExpertTooltipText }",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      "class-name": "btn-sm float-right",
                      text: _vm.$t("global.actions.importFromExpert"),
                      disabled: _vm.allowSave,
                    },
                    on: { click: _vm.importFromExpert },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("filogix-details-form", {
                    attrs: {
                      "show-equifax": false,
                      "show-verification-icon": "",
                    },
                    model: {
                      value: _vm.filogixDetails,
                      callback: function ($$v) {
                        _vm.filogixDetails = $$v
                      },
                      expression: "filogixDetails",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush bt-0" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("settings.accountTab.equifaxDetails")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("filogix-details-form", {
                    attrs: { "show-filogix": false },
                    model: {
                      value: _vm.filogixDetails,
                      callback: function ($$v) {
                        _vm.filogixDetails = $$v
                      },
                      expression: "filogixDetails",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isMppEnabled
        ? _c("div", { staticClass: "card" }, [
            _c("ul", { staticClass: "list-group list-group-flush bt-0" }, [
              _c(
                "li",
                { staticClass: "list-group-item" },
                [
                  _c("i18n", {
                    staticClass: "grey-text text-darken-3 m-0",
                    attrs: { tag: "p", path: "settings.accountTab.mppNote" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "mppLink",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: "https://co.manulife.ca/mppb",
                                  },
                                },
                                [_vm._v("https://co.manulife.ca/mppb")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      135470785
                    ),
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("import-from-expert-modal", {
        ref: "importFromExpertModal",
        attrs: { "filogix-details": _vm.filogixDetails },
        on: {
          updateExpertProfileNumber: _vm.updateExpertProfileNumber,
          update: _vm.updateLenderSubmissionDetails,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }